import { useMemo } from 'react';

import { isNotNull } from 'helpers/typescript';
import useOnClickOutside from 'hooks/useOnClickOutside';

export default function useOnClickOutsidePopover(
  contentRef: React.RefObject<HTMLElement | null>,
  triggerRef: React.RefObject<HTMLElement | null> | null,
  handler: (event: MouseEvent) => unknown,
  { selector, disabled }: { selector?: string | string[]; disabled?: boolean },
) {
  const clickOutsideRef = useMemo(() => {
    const refs = [contentRef];
    if (triggerRef != null) {
      refs.push(triggerRef);
    }
    return refs;
  }, [contentRef, triggerRef]);
  const selectorArray = useMemo(() => {
    const selectors = Array.isArray(selector) ? selector : [selector];
    return [`[role="menu"]`, ...selectors].filter(isNotNull);
  }, [selector]);

  useOnClickOutside(clickOutsideRef, handler, {
    disabled,
    selector: selectorArray,
  });
}
